<template>
  <v-btn text @click="$router.go(-1)"
    ><v-icon>mdi-arrow-left</v-icon> Назад</v-btn
  >
</template>

<script>
export default {
  name: "back-button"
};
</script>
